export const getInferredRunIdForUserMessage = (userMessageId: string): string => `run-after-${userMessageId}`;
